import type { GeologicIntervalListQueryResponse } from 'types/api-responses';

export type GeologicIntervalRow = GeologicIntervalListQueryResponse;

// Sentinel for the "Other…" custom-basin option in the Basin ComboBox.
export const OTHER_BASIN_ID = '__other__';

export interface BasinItem {
  id: string;
  text: string;
}

export interface GeologicIntervalBoundItem {
  id: string;
  text: string;
  name: string;
  positionalIndex: number;
}

export interface AddGeologicIntervalFormValues {
  basin: BasinItem | null;
  customBasin: string;
  intervalName: string;
  age: string;
  lithology: string;
  upperBound: GeologicIntervalBoundItem | null;
  lowerBound: GeologicIntervalBoundItem | null;
  displayColor: string;
}

// BE only accepts displayColor / age / lithology updates.
export interface EditGeologicIntervalFormValues {
  age: string;
  lithology: string;
  displayColor: string;
}

// ONC staged client-side; `tempId` is the React key — the real `id`
// arrives from the BE when the Save PATCH commits.
export interface PendingAddOnc {
  tempId: string;
  operator: { name: string | null; allOperators: boolean };
  targetZoneIdentifier: string;
}
